module.exports = __webpack_public_path__ + "static/media/Tuoreen_diabeetikon_alkuohjaus.1ab3a8d9.pdf";